<template>
    <div class="shows-filter-controls">
        <div class="left-section">
            <template v-for="mode in modes">
                <a
                    :key="mode"
                    class="mode-selector"
                    :class="[ layout === mode ? 'is-active' : '', mode ]"
                    @click.prevent="emitChange({ layoutType: mode })"
                />
            </template>
            <span class="counter">{{ showsLength }} shows</span>
        </div>
        <div class="right-section">
            <div class="filters">
                <base-checkbox
                    v-for="filter in filtersConfig"
                    :key="filter.type"
                    :values="activeFilters"
                    :value="filter.type"
                    :input-class="[`is-${filter.color}`, 'is-small']"
                    :label="filter.label"
                    @change="value => emitChange({ filters: value })"
                />
            </div>
            <base-select
                v-if="'grid' === layout"
                :options="selectConfig"
                select-prefix="Sort by:"
                @change="value => emitChange({ sortBy: value })"
            />
            <base-search-input
                placeholder="Search show..."
                @input="value => emitChange({ searchPhrase: value })"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: String,
            default: '',
        },
        filtersConfig: {
            type: Array,
            default: () => [],
        },
        selectConfig: {
            type: Array,
            default: () => [],
        },
        activeFilters: {
            type: Array,
            default: () => [],
        },
        showsLength: {
            type: Number,
            default: 0,
        },
    },

    data: () => ({
        modes: [
            'grid',
            'list',
        ],
    }),

    methods: {
        /**
         * Emits control changed
         *
         * @param   {string}  value  Value to be emited
         *
         */
        emitChange(value) {
            this.$emit('change', value);
        },
    },
};
</script>
